/**
 * エラーコードの定数定義
 */
export const ErrorCodeConstants = {
  // エラーコード一覧(4桁目'7'とする)
  ERROR_CODES: {
    EAPZ000001: 'EAP7000001',
    EAPZ000003: 'EAP7000003',
    EAPZ000004: 'EAP7000004',
    EAPZ000009: 'EAP7000009',
    EAPZ000010: 'EAP7000010',
    EAPZ000018: 'EAP7000018',
    EAPZ000019: 'EAP7000019',
    EAPZ000020: 'EAP7000020',
    EAPZ000050: 'EAP7000050',
    EAPZ000051: 'EAP7000051',
    EBAA000002: 'EBA7100002',
    EBAA000003: 'EBA7100003',
    EBAA000017: 'EBA7100017',
    EBAZ000015: 'EBA7000015',
    EIFA000001: 'EIF7100001',
    EIFA000002: 'EIF7100002',
    EIFA000003: 'EIF7100003',
    EIFA000004: 'EIF7100004',
    EIFA000005: 'EIF7100005',
    EIFA000006: 'EIF7100006',
    EIFA000007: 'EIF7100007',
    EIFA000008: 'EIF7100008',
    EIFA000009: 'EIF7100009',
    EIFA000011: 'EIF7100011',
    EIFA000012: 'EIF7100012',
    EIFA000013: 'EIF7100013',
    FDXZ000005: 'FDX7000005',
    FIFA000001: 'FIF7100001',
    // ここから画面固有
    EAPZ000027: 'EAP7000027',
    EBAA000028: 'EBA7100028',
    EBAZ000023: 'EBA7000023',
    EBAZ000078: 'EBA7000078',
    EBAZ000096: 'EBA7000096',
    EBAZ000097: 'EBA7000097',
    EBAZ000098: 'EBA7000098',
    EBAZ000106: 'EBA7000106',
    EBAZ000143: 'EBA7000143',
    EBAZ000145: 'EBA7000145',
    EBAZ000146: 'EBA7000146',
    EBAZ000147: 'EBA7000147',
    EBAZ000149: 'EBA7000149',
    EBAZ000151: 'EBA7000151',
    EBAZ000155: 'EBA7000155',
    EBAZ000157: 'EBA7000157',
    EBAZ000159: 'EBA7000159',
    EBAZ000160: 'EBA7000160',
    EBAZ000161: 'EBA7000161',
    EBAZ000162: 'EBA7000162',
    EBAZ000163: 'EBA7000163',
    EBAZ000164: 'EBA7000164',
    EBAZ000165: 'EBA7000165',
    EBAZ000189: 'EBA7000189',
    EBAZ000190: 'EBA7000190',
    EBAZ000191: 'EBA7000191',
    EBAZ000192: 'EBA7000192',
    EBAZ000193: 'EBA7000193',
    EBAZ000194: 'EBA7000194',
    EBAZ000195: 'EBA7000195',
    EBAZ000196: 'EBA7000196',
    EBAZ000197: 'EBA7000197',
    EBAZ000198: 'EBA7000198',
    EBAZ000246: 'EBA7000246',
    EBAZ000247: 'EBA7000247',
    EBAZ000248: 'EBA7000248',
    EBAZ000251: 'EBA7000251',
    EBAZ000252: 'EBA7000252',
    EBAZ000253: 'EBA7000253',
    EBAZ000254: 'EBA7000254',
    EBAZ000255: 'EBA7000255',
    EBAZ000256: 'EBA7000256',
    EBAZ000257: 'EBA7000257',
    EBAZ000258: 'EBA7000258',
    EBAZ000259: 'EBA7000259',
    EBAZ000260: 'EBA7000260',
    EBAZ000261: 'EBA7000261',
    EBAZ000262: 'EBA7000262',
    EBAZ000263: 'EBA7000263',
    EBAZ000264: 'EBA7000264',
    EBAZ000265: 'EBA7000265',
    EBAZ000266: 'EBA7000266',
    EBAZ000267: 'EBA7000267',
    EBAZ000268: 'EBA7000268',
    EBAZ000269: 'EBA7000269',
    EBAZ000270: 'EBA7000270',
    EBAZ000271: 'EBA7000271',
    EBAZ000298: 'EBA7000298',
    EBAZ000303: 'EBA7000303',
    EBAZ000304: 'EBA7000304',
    EBAZ000314: 'EBA7000314',
    EBAZ000315: 'EBA7000315',
    EBAZ000316: 'EBA7000316',
    EBAZ000367: 'EBA7000367',
    EBAZ000380: 'EBA7000380',
    EBAZ000384: 'EBA7000384',
    EBAZ000385: 'EBA7000385',
    EBAZ000386: 'EBA7000386',
    EBAZ000394: 'EBA7000394',
    EBAZ000396: 'EBA7000396',
    EBAZ000404: 'EBA7000404',
    EBAZ000406: 'EBA7000406',
    EBAZ000407: 'EBA7000407',
    EBAZ000408: 'EBA7000408',
    EBAZ000409: 'EBA7000409',
    EBAZ000410: 'EBA7000410',
    EBAZ000411: 'EBA7000411',
    EBAZ000413: 'EBA7000413',
    EBAZ000414: 'EBA7000414',
    EBAZ000416: 'EBA7000416',
    EBAZ000417: 'EBA7000417',
    EBAZ000418: 'EBA7000418',
    EBAZ000419: 'EBA7000419',
    EBAZ000421: 'EBA7000421',
    EBAZ000433: 'EBA7000433',
    EBAZ000434: 'EBA7000434',
    EBAZ000500: 'EBA7000500',
    EBAZ000520: 'EBA7000520',
    EBAZ000544: 'EBA7000544',
    EBAZ000584: 'EBA7000584',
    EBAZ000585: 'EBA7000585',
    EBAZ000587: 'EBA7000587',
    EBAZ000589: 'EBA7000589',
    EBAZ000596: 'EBA7000596',
    EBAZ000597: 'EBA7000597',
    EBAZ000615: 'EBA7000615',
    EBAZ000631: 'EBA7000631',
    EBAZ000638: 'EBA7000638',
    EBAZ000662: 'EBA7000662',
    EBAZ000674: 'EBA7000674',
    EBAZ000675: 'EBA7000675',
    EBAZ000676: 'EBA7000676',
    EBAZ000684: 'EBA7000684',
    EBAZ000707: 'EBA7000707',
    EBAZ000708: 'EBA7000708',
    EBAZ000709: 'EBA7000709',
    EBAZ000713: 'EBA7000713',
    EBAZ000722: 'EBA7000722',
    EBAZ000724: 'EBA7000724',
    EBAZ000727: 'EBA7000727',
    EBAZ000735: 'EBA7000735',
    EBAZ000736: 'EBA7000736',
    EBAZ000737: 'EBA7000737',
    EBAZ000738: 'EBA7000738',
    EBAZ000739: 'EBA7000739',
    EBAZ000745: 'EBA7000745',
    EBAZ000746: 'EBA7000746',
    EBAZ000747: 'EBA7000747',
    EBAZ000748: 'EBA7000748',
    EBAZ000749: 'EBA7000749',
    EBAZ000751: 'EBA7000751',
    EBAZ000752: 'EBA7000752',
    EBAZ000754: 'EBA7000754',
    EBAZ000755: 'EBA7000755',
    EBAZ000756: 'EBA7000756',
    EBAZ000767: 'EBA7000767',
    EBAZ000773: 'EBA7000773',
    EBAZ000778: 'EBA7000778',
    EBAZ000820: 'EBA7000820',
    EBAZ000822: 'EBA7000822',
    EBAZ000843: 'EBA7000843',
    EBAZ000846: 'EBA7000846',
    EBAZ000847: 'EBA7000847',
    EBAZ000848: 'EBA7000848',
    EBAZ000700: 'EBA7000700',
    EBAZ000702: 'EBA7000702',
    EBAZ000777: 'EBA7000777',
    ECLZ000001: 'ECL7000001',
    ECLZ000002: 'ECL7000002',
    ECLZ000003: 'ECL7000003',
    FOTO000001: 'FOT7000001',
    WBAZ000029: 'WBA7000029',
    WBAZ000030: 'WBA7000030',
    WBAZ000031: 'WBA7000031',
    WBAZ000032: 'WBA7000032',
    WBAZ000033: 'WBA7000033',
    WBAZ000034: 'WBA7000034',
    WBAZ000035: 'WBA7000035',
    WBAZ000036: 'WBA7000036',
    WBAZ000037: 'WBA7000037',
    WBAZ000038: 'WBA7000038',
    WBAZ000039: 'WBA7000039',
    WBAZ000040: 'WBA7000040',
    WBAZ000043: 'WBA7000043',
    WBAZ000044: 'WBA7000044',
    WBAZ000045: 'WBA7000045',
    WBAZ000048: 'WBA7000048',
    WBAZ000152: 'WBA7000152',
    WBAZ000198: 'WBA7000198',
    WBAZ000213: 'WBA7000213',
    WBAZ000214: 'WBA7000214',
    WBAZ000218: 'WBA7000218',
    WBAZ000219: 'WBA7000219',
    WBAZ000223: 'WBA7000223',
    WBAZ000224: 'WBA7000224',
    WBAZ000225: 'WBA7000225',
    WBAZ000226: 'WBA7000226',
    WBAZ000238: 'WBA7000238',
    WBAZ000239: 'WBA7000239',
    WBAZ000241: 'WBA7000241',
    WBAZ000242: 'WBA7000242',
    WBAZ000253: 'WBA7000253',
    WBAZ000254: 'WBA7000254',
    WBAZ000257: 'WBA7000257',
    WBAZ000355: 'WBA7000355',
    WBAZ000389: 'WBA7000389',
    WBAZ000428: 'WBA7000428',
    WBAZ000556: 'WBA7000556',
    WBAZ000557: 'WBA7000557',
    WBAZ000558: 'WBA7000558',
    WBAZ000562: 'WBA7000562',
    WBAZ000563: 'WBA7000563',
    WBAZ000564: 'WBA7000564',
    WBAZ000573: 'WBA7000573',
    WBAZ000577: 'WBA7000577',
    WBAA100012: 'WBA7100012',
    EBAA000029: 'EBA7100029',
    EBAA000030: 'EBA7100030',
    EBAA000037: 'EBA7100037',
    EBAA000046: 'EBA7100046',
  },
};

/**
 * 共通処理で利用する定数の定義
 */
export const CommonConstants = {
  THREE_LETTER: 'SFJ',
  // オフィスコードチェック用定数
  OFFICE_CODE_JP: 'KKJ7G08', // 日本統合オフィスコード
  OFFICE_CODE_JP_R: 'KKJ7G08AA', // 有償日本オフィス
  OFFICE_CODE_JP_R_APF: '', // 有償日本オフィスAPF
  OFFICE_CODE_JP_A: 'KKJ7G08ZZ', // 特典日本オフィス
  // 提携3社ログインモーダルで(ADO,SFJ,SNJ)会員番号チェック用定数
  MEMBER_NUMBER_RULES: {
    type: 'numberic' as 'alphaNumberic' | 'numberic',
    length: 10,
  },
  // ログインモーダルのパスワードチェック用定数
  PASSWORD_RULES: {
    minPwLength: 8,
    maxPwLength: 16,
    pwRegex: '^[a-zA-Z0-9-_.+$#!/@(%&*?)]*$',
  },
  // ログイン情報連携機能が有効か
  LOGIN_INFO_INTEGRATION_ENABLED: false,
  // 提携社サイトに戻る際のURL切り替え機能が有効か
  RETURN_URL_SWITCH_ENABLED: false,
  LOGO_FILE_PATH: 'assets/images/logo_sfj.svg',
  // 法人ヘッダー用ロゴファイルパス
  LOGO_BIZ_FILE_PATH: 'assets/images/logo_sfj_black.svg',
  // ログインAPIエラーコードMAP
  LOGIN_API_ERROR_MAP: {
    [ErrorCodeConstants.ERROR_CODES.EIFA000001]: 'EA021', // ログイン情報なし
    [ErrorCodeConstants.ERROR_CODES.EIFA000002]: 'EA022', // ログイン情報が無効
    [ErrorCodeConstants.ERROR_CODES.EIFA000003]: 'EA014', // 一定時間内のログイン試行回数超過によりブロックされた会員
    [ErrorCodeConstants.ERROR_CODES.EIFA000004]: 'EA020', // パスワード不一致
    [ErrorCodeConstants.ERROR_CODES.EIFA000005]: 'EA013', // パスワード有効期限切れ
    [ErrorCodeConstants.ERROR_CODES.EIFA000006]: 'EA016',
    [ErrorCodeConstants.ERROR_CODES.EIFA000007]: 'EA023',
    [ErrorCodeConstants.ERROR_CODES.EIFA000008]: 'EA024',
    [ErrorCodeConstants.ERROR_CODES.EIFA000009]: 'EA017',
    [ErrorCodeConstants.ERROR_CODES.EIFA000011]: 'EA015',
    [ErrorCodeConstants.ERROR_CODES.EIFA000012]: 'EA018',
    [ErrorCodeConstants.ERROR_CODES.EIFA000013]: 'EA025',
    [ErrorCodeConstants.ERROR_CODES.EBAA000002]: 'EA050', // 会員区分が無効会員の場合
    [ErrorCodeConstants.ERROR_CODES.EBAA000003]: 'EA051', // 認証結果がfalse
    [ErrorCodeConstants.ERROR_CODES.EBAA000017]: 'EA027', // 会員情報がダミー値
    [ErrorCodeConstants.ERROR_CODES.EAPZ000009]: 'E0361', // 搭乗者に含まれているかチェック
    [ErrorCodeConstants.ERROR_CODES.EAPZ000010]: 'E0361', // マイル減算者の会員かチェックエラー
    [ErrorCodeConstants.ERROR_CODES.FIFA000001]: 'EA019', // ifly接続エラー(想定外エラー)
  } as { [key: string]: string },
  // InlineTelemetry付与対象URL
  INLINETELEMETRY_URL: {
    AUTH_LOGIN: {
      ENDPOINT: /\/all-.*-member\/api\/.*\/auth-login/,
      METHOD: 'POST',
    },
    PAYMENT_RECORD: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/payment-records/,
      METHOD: 'POST',
    },
    CREATE_ORDER: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/orders\/create-order/,
      METHOD: 'POST',
    },
    CAPTCHA_AUTHENTICATION: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/captcha-authentication$/,
      METHOD: 'POST',
    },
    CREATE_CART: {
      ENDPOINT: /\/all-.*-reservation\/api\/.*\/carts\/create-cart/,
      METHOD: 'POST',
    },
    ROUNDTRIP_FPP: {
      ENDPOINT: /\/all-.*-search\/api\/.*\/roundtrip-fpp/,
      METHOD: 'POST',
    },
  } as { [key: string]: { ENDPOINT: RegExp; METHOD: string } },
} as const;

/**
 * APP内で利用する定数の定義
 */
export const AppConstants = {
  // 画像の定数一覧
  IMG: {
    LOGO_S: 'assets/images/logo_sfj_s.svg',
    LOGO_BIZ: 'assets/images/logo_sfj_s.svg',
    LOGO_S_WIDTH: '86',
    LOGO_S_HEIGHT: '22',
    LOGO_BIZ_WIDTH: '86',
    LOGO_BIZ_HEIGHT: '22',

    // ツールチップ
    ICON_HELP: 'assets/images/icon_help_sfj_red_dark_20.svg',

    // S01-P010-S01-U: 予約検索画面
    S01_P010_S01_U_XXX: '',

    // S01-P020-S01-U: 予約一覧画面
    S01_P020_S01_U_XXX: '',
    S01_P020_S01_U__ICON__ERROR_TRI_20: `assets/images/icon_error_tri_sfj_red_20.svg`,
    S01_P020_S01_U__ICON__LINK_PRIMARY_20: `assets/images/icon_link_primary_20.svg`,

    // S01-P030-S01-U: 予約詳細画面
    S01_P030_S01_U_XXX: '',
    S01_P030_S01_U__LINK: 'assets/images/icon_link_white_20.svg',
    S01_P030_S01_U__PLANE_ACTIVE: 'assets/images/icon_plane_line_32.svg',
    S01_P030_S01_U__AVATOR_ACTIVE: 'assets/images/icon_avator_32.svg',
    S01_P030_S01_U__CHECKIN_SEAT_ACTIVE: 'assets/images/icon_checkin_seat_32.svg',
    S01_P030_S01_U__TOOLTIP: 'icon_help_sfj_red_dark_20.svg',
    S01_P030_S01_U__ANOTHER_WINDOW: 'assets/images/icon_external_16.svg',
    S01_P030_S01_U__Wifi_AVAILABLE: 'icon_wifi_20.svg',
    S01_P030_S01_U__Wifi_NOT_AVAILABLE: 'icon_wifi_not_available_20.svg',
    S01_P030_S01_U__Wifi_POSSIBLY_AVAILABLE: 'icon_wifi_possibly_20.svg',

    // S01-P031-S01-U: 予約詳細(旅程)画面
    S01_P031_S01_U_XXX: '',

    // S01-P032-S01-U: 予約詳細(搭乗者)画面
    S01_P032_S01_U_XXX: '',

    // S01-P033-S01-U: 予約詳細(サービス)画面
    S01_P033_S01_U_XXX: '',

    // S02-P013-S01-U: ジュニアパイロット申込画面
    S02_P013_S01_U_XXX: '',

    // S03-P010-S01-U: シートマップ画面
    S03_P010_S01_U_XXX: '',
    S03_P010_S01_U__SEATMAP__SEATMAP_AISLE_SHORT: `assets/images/seatmap_aisle_short.svg`,
    S03_P010_S01_U__SEGMENTS__ICON_CHECK_PRIMARY_20: `assets/images/icon_check_20.svg`,
    S03_P010_S01_U__SEAT_PRODUCTS_MODAL__ICON_EXTERNAL_PRIMARY_16: `assets/images/icon_external_16.svg`,
    S03_P010_S01_U__LEGENDS_MODAL__BTN_ARROW_CIRCLE_LEFT_40: `assets/images/btn_arrow_circle_left_40.svg`,
    S03_P010_S01_U__LEGENDS_MODAL__BTN_ARROW_CIRCLE_RIGHT_40: `assets/images/btn_arrow_circle_right_40.svg`,
    S03_P010_S01_U__FLOADING_NAVI__SEATMAP_FLOAT_DETAIL: `不使用`,
    S03_P010_S01_U__FLOADING_NAVI__SEATMAP_FLOAT_SEATTYPE: `assets/images/seatmap_float_seattype_sfj.svg`,
    S03_P010_S01_U__FLOADING_NAVI__SEATMAP_FLOAT_LEGEND: `assets/images/seatmap_float_legend_sfj.svg`,
    S03_P010_S01_U__SEAT_EXITDOOR: `assets/images/seat_exitdoor_sfj.svg`,
    S03_P010_S01_U__SEAT_FREE_SEAT_24: `assets/images/seat_sfj_seat_24.svg`,
    S03_P010_S01_U__SEAT_BACK_SEAT_24: `assets/images/seat_back_seat_24.svg`,
    S03_P010_S01_U__SEAT_EMERGENCY_EXIT_SEAT_24: `assets/images/seat_emergency_exit_seat_sfj_24.svg`,
    S03_P010_S01_U__SEAT_UNAVAILABLE_24: `assets/images/seat_unavailable_24.svg`,
    S03_P010_S01_U__SEAT_INFANT_24: `assets/images/seat_infant_24.svg`,
    S03_P010_S01_U__SEAT_SELECTED_24: `assets/images/seat_selected_sfj_24.svg`,
    S03_P010_S01_U__SEAT_BEFORE_CHANGE_FREE_SEAT_24: `assets/images/seat_before_change_free_seat_sfj_24.svg`,
    S03_P010_S01_U__SEAT_UNCHANGEABLE_24: `assets/images/seat_unchangeable_sfj_24.svg`,
    S03_P010_S01_U__SEAT_NO_WINDOW_24: `assets/images/seat_no_window_sfj_24.svg`,
    S03_P010_S01_U__SEAT_NO_WINDOW: `assets/images/seat_no_window.svg`,
    S03_P010_S01_U__SEAT_NO_RECLINING_24: `assets/images/seat_no_reclining_sfj_24.svg`,
    S03_P010_S01_U__SEAT_NO_RECLINE: `assets/images/seat_no_recline_sfj.svg`,
    S03_P010_S01_U__SEAT_TABLE_24: `assets/images/seat_table_24.svg`,
    S03_P010_S01_U__SEAT_LAVATORY_24: `assets/images/seat_lavatory_sfj_24.svg`,
    S03_P010_S01_U__SEAT_MULTI_PURPOSE_ROOM_24: `assets/images/seat_multi_purpose_room_24.svg`,
    S03_P010_S01_U__SEAT_AISLE_24: `assets/images/seat_aisle_24.svg`,
    S03_P010_S01_U__SEAT_EMERGENCY_EXIT_24: `assets/images/seat_emergency_exit_24.svg`,
    S03_P010_S01_U__SEAT_WING_24: `assets/images/seat_wing_sfj_24.svg`,
    S03_P010_S01_U__SEAT_GALLEY_24: `assets/images/seat_galley_sfj_24.svg`,
    S03_P010_S01_U__SEAT_PARTITION_24: `assets/images/seat_partition_24.svg`,
    S03_P010_S01_U__SEAT_BAR_24: `assets/images/seat_bar_24.svg`,
    S03_P010_S01_U__SEAT_STAIR_24: `assets/images/seat_stair_24.svg`,
    S03_P010_S01_U__SEAT_BASSINET_24: `assets/images/seat_bassinet_24.svg`,

    // S03-P020-S01-U: 座席属性指定画面
    S03_P020_S01_U_XXX: '',

    // S03-P030-S01-U: シートマップ（参照）画面
    S03_P030_S01_U_XXX: '',

    // S04-P010-S01-U: 搭乗者情報入力画面
    S04_P010_S01_U_XXX: '',

    // S05-P011-S01-U: 領収書選択画面
    S05_P011_S01_U_XXX: '',

    // S05-P020-S01-U: 搭乗証明書検索画面
    // TODO: 定数が確定するまでの暫定です
    S05_P020_S01_U_XXX: '',
    S05_P020_S01_U__TOOLTIP: 'assets/images/icon_help_sfj_red_dark_24.svg',
  },

  // 定数一覧
  CARRIER: {
    TWO_LETTER: '7G',
    THREE_LETER: 'SFJ',
  },
} as const;
